<template>
  <togglable-caret-header 
    class="card-header header__link" 
    :id="'heading'+index"
    :data-bs-target="'#collapse'+index"
    :showCaret='showCaret'>
    <a role="button">
      {{ procedure.lodate }}
      <!-- if it is a regular procedure, get description by ccd -->
      <text-highlight :queries="keywords" class="header__link__desc">
        {{ (procedure.cdas[0] > 0 ? getProcDescById(procedure.ids[0], allData):getDescByCcd(procedure.codes[0], allData)).toLowerCase() }}
      </text-highlight>
      <router-link v-if="typeof procedure.cda !== 'undefined' " :to="{ name: 'CdasNavigation', params: { index: procedure.cda, fileType: CDA_FILE_TYPE}}" class="float-right">
        View in CDA
      </router-link>

    </a>
    <router-link v-if="procedure.reports[0] > 0"
                 :to="{ name: 'ReportsNavigation', params: { selectedReport: reportIndex, fileType: REPORT_FILE_TYPE } }"
                 class="float-right">
      View report
    </router-link>
  </togglable-caret-header>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  getDescByCcd,
  getProcDescById,
  getMeasIdsByProcId 
} from '@/data/getters';
import TogglableCaretHeader from '@/components/includes/TogglableCaretHeader';
import {REPORT_FILE_TYPE, CDA_FILE_TYPE} from "../../../config";

export default {
  name: "procedure-header",
  components: {
    'togglable-caret-header': TogglableCaretHeader
  },
  props: {
    procedure: {},
    index: {
      type: String,
      default: ''
    },
    keywords: Array
  },
  data() {
    return {
      REPORT_FILE_TYPE,
      CDA_FILE_TYPE
    }
  },
  computed: {
    showCaret() {
      let allData = this.allData;
      let procedure = this.procedure;
      if(procedure.isFromReport)
        return false;
      let showCaret = false;
      procedure.ids.forEach(procid => {
        let measids = getMeasIdsByProcId(procid,allData);
        if(measids && measids.length)
          showCaret = true;
      });
      return showCaret;
    },
    ...mapGetters('login', {
      allData: 'getAllData'
    }),
    reportId () {
      return this.procedure.reportId;
    },
    reportIndex() {
      return this.procedure.reportIndex;
    }
  },
  methods: {
    getDescByCcd,
    getProcDescById,
    getMeasIdsByProcId
  }
}
</script>

<style scoped lang="scss">
  .card-header {
    border-bottom: none;
    background-color: #fff;
    width: 100%;
  }

  .header__link {
    /*word-break: normal;*/
    white-space: normal;
    width: 100%;
    text-transform: capitalize;

    &:hover {
      cursor: pointer;
    }

    .header__link__desc {
      text-transform: capitalize;
    }
  }

</style>
